import { Client } from '../../client';
import type { ICustomerSession, SessionFlow } from '../../../entities';
import { CustomerSession } from '../../../entities';
import { InternalStripeRepository } from '../../repositories/internalStripeRepository';
import { handleErrors } from '../../../helpers';
import {
  CustomerSessionResponse,
  CheckoutSessionResponse,
} from '../../../responses/responseTypes';

export default class InternalStripeRepositoryImpl
  implements InternalStripeRepository
{
  protectedClient: Client;

  publicClient: Client;

  constructor(protectedClient: Client, publicClient: Client) {
    this.protectedClient = protectedClient;
    this.publicClient = publicClient;
  }

  async createSession(data: {
    returnUrl: string;
    flowType?: SessionFlow;
    successUrl?: string;
    songId?: string;
    releaseId?: string;
    isDistributionUpsellFlow?: boolean;
  }): Promise<ICustomerSession> {
    const { protectedClient } = this;
    const {
      returnUrl,
      flowType,
      successUrl,
      songId,
      releaseId,
      isDistributionUpsellFlow,
    } = data;

    return new Promise((resolve, reject) => {
      protectedClient
        .post<CustomerSessionResponse>('/stripe/customer/session', {
          return_url: returnUrl,
          ...(flowType && { flow_type: flowType }),
          ...(successUrl && { success_url: successUrl }),
          ...(songId && { song_id: songId }),
          ...(releaseId && { release_id: releaseId }),
          ...(isDistributionUpsellFlow && {
            distribution_upsell_flow: isDistributionUpsellFlow,
          }),
        })
        .then((response) => {
          resolve(new CustomerSession(response.data));
        })
        .catch((err) => {
          const error = handleErrors(err);
          reject(error);
        });
    });
  }

  createCheckoutSession(
    priceId: string,
    successURL: string,
    cancelURL: string
  ): Promise<{ checkoutURL: string }> {
    const { protectedClient } = this;

    return new Promise((resolve, reject) => {
      protectedClient
        .post<CheckoutSessionResponse>('/stripe/checkout-session', {
          price_id: priceId,
          success_url: successURL,
          cancel_url: cancelURL,
          platform: 'web_app',
          device_type: 'desktop',
        })
        .then((response) => {
          resolve({ checkoutURL: response.data.checkout_session_url });
        })
        .catch((err) => {
          const error = handleErrors(err);
          reject(error);
        });
    });
  }
}
